import { apiRequest } from "../client";

export interface Location {
  locationID: string;
  subdistrict: string;
  district: string;
  province: string;
  postCode: string;
}

export function searchLocations(searchText: string): Promise<Location[]> {
  return apiRequest("POST", "/v1/master-data/location", { searchText });
}
